export default "__VITE_ASSET__DCaF_TL8__"